import React, { FC, JSX, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import {
  FlexiableBooking,
  IncredibleDeals,
  NextSwiperArrow,
  NoFlight,
  PrevSwiperArrow,
} from "@/components/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useRouter } from "next/router";
interface OurFeaturesProps {
  data: {
    title: string;
    description: string;
    icon: string;
  }[];
}

const OurFeatures: FC<OurFeaturesProps> = ({ data }) => {
  const iconMap: Record<string, JSX.Element> = {
    FlexiableBooking: <FlexiableBooking />,
    NoFlight: <NoFlight />,
    IncredibleDeals: <IncredibleDeals />,
  };
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const router = useRouter();
  const isRtl = router.locale === "ar";
  const handleSwiper = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const handleSlideChange = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };
  return (
    <Box className="flex w-full max-w-[1328px] items-center justify-between gap-9 relative mx-auto mb-20 flex-wrap px-4">
      <div
        className={`swiper-button-prev-custom swiper-button-prev-custom-C transition-opacity duration-200 ${
          isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <PrevSwiperArrow />
      </div>
      <div
        className={`swiper-button-next-custom swiper-button-next-custom-C  transition-opacity duration-200 ${
          isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <NextSwiperArrow />
      </div>

      <div className="overflow-hidden max-w-[1312px]">
        <Swiper
          dir={isRtl ? "rtl" : "ltr"}
          key={isRtl ? "rtl" : "ltr"}
          spaceBetween={16}
          slidesPerView={1}
          slidesPerGroup={1}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 16,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          }}
          navigation={{
            nextEl: ".swiper-button-next-custom-C",
            prevEl: ".swiper-button-prev-custom-C",
          }}
          modules={[Navigation]}
          className="mySwiper1"
          onSwiper={handleSwiper}
          onSlideChange={handleSlideChange}
        >
          {data.map((feature, index) => (
            <SwiperSlide key={index} className="!rounded-[10px]">
              <Stack
                key={index}
                spacing={2}
                className="c-lg:flex-[0_0_auto]  max-c-md:px-4 gap-2 c-lg:max-w-full c-lg:flex-row flex-col c-lg:items-center items-center"
              >
                <Box className="w-[90px] h-[90px] min-w-[90px] bg-secondary rounded-full flex items-center justify-center">
                  {iconMap[feature.icon]}
                </Box>

                <Stack
                  spacing={1.5}
                  className="flex flex-col justify-center items-center text-center"
                >
                  <Typography
                    variant="h6"
                    className="text-[28px] font-semibold leading-9 !text-primary"
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    className="text-base font-normal leading-8 c-lg:w-[305px] w-full"
                  >
                    {feature.description}
                  </Typography>
                </Stack>
              </Stack>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Box>
  );
};

export default OurFeatures;
